import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = { style: {"margin-bottom":"0"} }
const _hoisted_3 = { style: {"margin-bottom":"0"} }

import { computed } from 'vue'
import BaseModule from './BaseModule.vue'
import {
  NProgress,
  NInputNumber,
  NInputGroup,
  NInputGroupLabel,
  NForm,
  NFormItem,
} from 'naive-ui'
import { useI18n } from 'vue-i18n'

import { useMqttStore } from '@/store/mqttStore'
import { useDeviceStore } from '@/store/deviceStore'
import { storeToRefs } from 'pinia'

import {
  cranksetDefinitions,
  cranksetCadence,
  cranksetSmoothnessLeft,
  cranksetSmoothnessRight,
} from '@/mqttDefinitions'

import { valueAsPercentage, CADENCE_MAX } from '@/outputVariables'


export default /*@__PURE__*/_defineComponent({
  __name: 'PedallingAnalyzerModule',
  setup(__props) {

const { t } = useI18n()
const mqttStore = useMqttStore()
const deviceStore = useDeviceStore()
const { getMessageOnTopic } = storeToRefs(mqttStore)
const { motorStatus } = storeToRefs(deviceStore)

const cadence = computed(() => {
  return getMessageOnTopic.value(cranksetCadence)
})

const cadenceAsPercentage = computed(() => {
  return valueAsPercentage(cadence.value, CADENCE_MAX)
})

const smoothnessLeft = computed(() => {
  return getMessageOnTopic.value(cranksetSmoothnessLeft)
})

const smoothnessRight = computed(() => {
  return getMessageOnTopic.value(cranksetSmoothnessRight)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModule, {
    definition: _unref(cranksetDefinitions),
    installed: false,
    error: _unref(motorStatus).highTemperature,
    "content-active": 
      !_unref(motorStatus).overcurrent &&
      !_unref(motorStatus).stalled &&
      !_unref(motorStatus).highTemperature
    
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('modules.pedalAnalyzer.index')), 1)
    ]),
    left: _withCtx(() => [
      _createVNode(_unref(NProgress), {
        type: "circle",
        percentage: cadenceAsPercentage.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(cadence.value), 1),
            _createElementVNode("h5", _hoisted_3, _toDisplayString(_unref(cranksetCadence).unit), 1)
          ])
        ]),
        _: 1
      }, 8, ["percentage"])
    ]),
    right: _withCtx(() => [
      _createVNode(_unref(NForm), {
        ref: "formRef",
        "label-placement": "left"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), { label: "L" }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputNumber), {
                    value: smoothnessLeft.value,
                    "show-button": false,
                    readonly: ""
                  }, null, 8, ["value"]),
                  _createVNode(_unref(NInputGroupLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(cranksetSmoothnessLeft).unit), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(NFormItem), { label: "R" }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputNumber), {
                    value: smoothnessRight.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((smoothnessRight).value = $event)),
                    "show-button": false
                  }, null, 8, ["value"]),
                  _createVNode(_unref(NInputGroupLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(cranksetSmoothnessRight).unit), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["definition", "error", "content-active"]))
}
}

})